import {
  formatDate,
  BaseTransaction,
  SelectItemProps,
  formatBalance,
  BaseellaStatusTitle,
  Currency,
} from '@ui/src';
import getGeneralLedgerStatusTitle from '../../general-ledger/helpers/get-gl-enum-names';
import { PaymentType } from '../../../store/types';

import cn from '../styles.module.css';

const formatIncomingList = ({
  list,
  countries,
  currenciesList,
  paymentTypes,
}: {
  list: BaseTransaction[];
  countries: SelectItemProps[];
  currenciesList?: Currency[];
  paymentTypes?: PaymentType[];
}): BaseTransaction[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const currentCurrency = currenciesList?.find(
      (currency) => currency.id === result.currencyId,
    );

    const currentPaymentType = paymentTypes?.find(
      (type) => type.paymentType === item.paymentType,
    );

    const render: Record<string, any> = {
      transferDate: <div>{formatDate(result?.transferDate || '', true)}</div>,
      acceptedIn: <div>{formatDate(result?.acceptedIn || '') || '—'}</div>,
      currencyId: <div>{result?.currency?.name || ''}</div>,
      recipientAccountNumber: result?.recipientAccount ? (
        <>
          <div>{result?.recipientAccount?.description}</div>
          <div className={cn.accNumber}>
            {result?.recipientAccount?.fullNumber}
          </div>
        </>
      ) : (
        result.recipientAccountNumber
      ),
      remitterCountry: (
        <div>
          {countries.find((el) => el.value === result.remitterCountry)?.name ||
            ''}
        </div>
      ),
      remitterBankCountry: (
        <div>
          {countries.find((el) => el.value === result.remitterBankCountry)
            ?.name || ''}
        </div>
      ),
      intermediaryBankCountry: (
        <div>
          {countries.find((el) => el.value === result.intermediaryBankCountry)
            ?.name || ''}
        </div>
      ),
      paymentType: <div>{currentPaymentType?.name}</div>,
      sum: <div>{formatBalance(result.sum, currentCurrency)}</div>,
      baseellaStatus: <div>{BaseellaStatusTitle[result.baseellaStatus]}</div>,
      documentNumber: (
        <div className={cn.documentInfoRow}>{result.documentNumber}</div>
      ),
      info: <div className={cn.documentInfoRow}>{result.info}</div>,
      values: result.generalLedgerTransactions?.edges.map((el) => el.node),
    };

    result.render = render;

    const nextResult = {
      ...result,
      values:
        result.generalLedgerTransactions?.edges.map((el) => {
          const gl = el.node;

          const glCurrency = currenciesList?.find(
            (currency) => currency.id === gl.currencyId,
          );

          return {
            ...gl,
            render: {
              transferDate: (
                <div>{formatDate(gl?.transferDate || '', true)}</div>
              ),
              currencyId: <div>{gl?.currency.name || ''}</div>,
              debitAccountId: <div>{gl?.debitAccount?.fullNumber || ''}</div>,
              creditAccountId: <div>{gl?.creditAccount?.fullNumber || ''}</div>,
              debitAccount: <div>{gl?.debitAccount?.description || ''}</div>,
              creditAccount: <div>{gl?.creditAccount?.description || ''}</div>,
              sum: <div>{formatBalance(gl.sum, glCurrency)}</div>,
              status: (
                <div>{getGeneralLedgerStatusTitle(gl?.status || '')}</div>
              ),
            },
          };
        }) || [],
    };

    return nextResult;
  });

  return nextList;
};

export default formatIncomingList;
